import React, {useContext} from 'react';
import {
  Input,
  FormGroup,
  Col,
  Row
} from 'reactstrap';
import {QuestionAnswers} from '../../../../context';


const NumberQuestion = ({text,questionPrompt,handleChange,questionKey}) => {
  
  const {[questionKey]:value=''} = useContext(QuestionAnswers);
  
  return (
    <div>
      <p>{text}</p>
      <br/>
      {questionPrompt && questionPrompt}
      <Row>
        <Col lg={6}>
          <FormGroup>
            <Input
              value={value}
              type="number"
              onChange={e => handleChange(e.target.value)}
            />
          </FormGroup>
        </Col>
      </Row>
    </div>
  );
};

export default NumberQuestion;